import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../home/components/Footer';

export default function CaseBaitForFishPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const stagesWork = [
    {
      img: 'https://convertmonster.ru/wp-content/themes/convertmonster/img/cm-2023/cases/default_img_dunaev_opt_big_2.jpg',
      text: 'По словам клиента, на продажах прикормки Dunaev можно зарабатывать от 300 000 руб. за сезон. Эту информацию мы сделали главным оффером и разместили на первом экране.',
      label: 'Экран 1 — Главный оффер',
    },
    {
      img: 'https://convertmonster.ru/wp-content/themes/convertmonster/img/cm-2023/cases/default_img_dunaev_opt_big_3.jpg',
      text: 'У клиента есть и другие выгодные условия для работы. О них мы рассказали в блоке под первым экраном.',
      label: 'Экран 2 — Условия сотрудничества',
    },
    {
      img: 'https://convertmonster.ru/wp-content/themes/convertmonster/img/cm-2023/cases/default_img_dunaev_opt_big_4.jpg',
      text: 'Далее посетитель сайта может оставить свои контакты, чтобы его проконсультировали об условиях сотрудничества.',
      label: 'Экран 3 — Форма сбора контактов',
    },
    {
      img: 'https://convertmonster.ru/wp-content/themes/convertmonster/img/cm-2023/cases/default_img_dunaev_opt_big_5.jpg',
      text: 'Так как на рынке рыболовных товаров много конкурентов, на сайте мы разместили блок, почему именно с «Дунаевым» выгодно и безопасно сотрудничать. Дополнительным доказательством этих причин ниже поместили видеоролик о самом продукте.',
      label: 'Экран 4 — Преимущества бренда',
    },
    {
      img: 'https://convertmonster.ru/wp-content/themes/convertmonster/img/cm-2023/cases/default_img_dunaev_opt_big_6.jpg',
      text: 'У заказчика широкий ассортимент продукции. И мы сделали понятный и удобный каталог, после которого поставили кнопку для скачивания полного прайс-листа.',
      label: 'Экран 5 — Каталог продукции (часть 1)',
    },
    {
      img: 'https://convertmonster.ru/wp-content/themes/convertmonster/img/cm-2023/cases/default_img_dunaev_opt_big_7.jpg',
      text: 'Полный каталог ассортимента с возможностью скачать прайс-лист — удобное решение для оптовых покупателей.',
      label: 'Экран 6 — Каталог продукции (часть 2)',
    },
    {
      img: 'https://convertmonster.ru/wp-content/themes/convertmonster/img/cm-2023/cases/default_img_dunaev_opt_8.jpg',
      text: '«Дунаев» на рынке не первый год и успел собрать большую базу довольных покупателей. О них на сайте рассказывается в блоке с кейсами.',
      label: 'Экран 7 — Отзывы и кейсы клиентов',
    },
    {
      img: 'https://convertmonster.ru/wp-content/themes/convertmonster/img/cm-2023/cases/default_img_dunaev_opt_big_9.jpg',
      text: 'После кейсов мы еще раз поставили блок о причинах, почему стоит выбрать Dunaev, и кнопку для оформления заявки. Для имиджа на сайте разместили видео обращение самого основателя компании Александра Дунаева, так как он является популярной личностью в рыболовной сфере.',
      label: 'Экран 8 — Повторный блок доверия + видео',
    },
    {
      img: 'https://convertmonster.ru/wp-content/themes/convertmonster/img/cm-2023/cases/default_img_dunaev_opt_big_10.jpg',
      text: 'Чтобы посетителям наглядно показать разницу между Dunaev и остальными поставщиками, разработали и поставили сравнительную таблицу.',
      label: 'Экран 9 — Сравнительная таблица',
    },
    {
      img: 'https://convertmonster.ru/wp-content/themes/convertmonster/img/cm-2023/cases/default_img_dunaev_opt_big_11.jpg',
      text: 'Если у посетителя после просмотра лендинга остались вопросы, ответы на них он может найти в блоке «Вопрос-ответ».',
      label: 'Экран 10 — FAQ',
    },
    {
      img: 'https://convertmonster.ru/wp-content/themes/convertmonster/img/cm-2023/cases/default_img_dunaev_opt_12.jpg',
      text: 'Еще одной сильной стороной клиента является опытная команда сотрудников. О них мы тоже рассказали.',
      label: 'Экран 11 — Команда',
    },
    {
      img: 'https://convertmonster.ru/wp-content/themes/convertmonster/img/cm-2023/cases/default_img_dunaev_opt_13.jpg',
      text: 'И в конце сайта разместили контактную информацию с картой и формой «Обратный звонок». Также «Дунаев» активно ведет соц.сети и видео блог, на них также даны ссылки.',
      label: 'Экран 12 — Контакты и соцсети',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="pt-24 sm:pt-32 pb-12 sm:pb-16 bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] relative overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 border-2 border-[#C5A880]/20 rounded-full -mr-48 -mt-48 hidden sm:block"></div>
        <div className="absolute bottom-0 left-0 w-72 h-72 border-2 border-[#C5A880]/20 rounded-full -ml-36 -mb-36 hidden sm:block"></div>
        <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-[#C5A880]/5 rounded-full -translate-x-1/2 -translate-y-1/2"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-6 sm:mb-8">
            <Link
              to="/case"
              className="inline-flex items-center gap-2 text-[#C5A880] hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-lg"></i>
              <span className="text-sm font-medium font-['Montserrat']">Назад к кейсам</span>
            </Link>

            <div className="inline-block bg-[#C5A880] text-[#1A2B4C] px-3 sm:px-5 py-2 rounded-full text-xs sm:text-sm font-bold shadow-lg font-['Montserrat'] whitespace-normal sm:whitespace-nowrap text-center">
              Кейс: Разработка веб-сайта + Контекстная реклама
            </div>
          </div>

          <div className="mb-8 sm:mb-10">
            <div>
              <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-3 sm:mb-4 leading-tight font-['Playfair_Display']">
                Создание веб-сайта для оптовой продажи рыболовной прикормки: улов в 132 конверсии за два месяца
              </h1>
              <p className="text-[#C5A880]/90 text-base sm:text-xl font-['Montserrat']">
                За два месяца работы рекламных кампаний мы получили 132 конверсии со средней стоимостью 584 руб.
              </p>
            </div>
          </div>

          {/* Hero Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 mt-2">
            {[
              { value: '77 119 ₽', label: 'Бюджет' },
              { value: '19,18 ₽', label: 'Цена клика' },
              { value: '132 шт', label: 'Конверсий' },
              { value: '584 ₽', label: 'Цена конверсии' },
            ].map((stat, i) => (
              <div
                key={i}
                className="bg-white/10 backdrop-blur-sm border border-[#C5A880]/30 rounded-xl sm:rounded-2xl px-3 sm:px-6 py-4 sm:py-5 text-center hover:bg-white/15 transition-all duration-300"
              >
                <div className="text-xl sm:text-2xl md:text-3xl font-bold text-[#C5A880] font-['Playfair_Display']">
                  {stat.value}
                </div>
                <div className="text-white/80 text-xs sm:text-sm mt-1 font-['Montserrat']">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-10 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">

          {/* Client + Task */}
          <div className="grid md:grid-cols-2 gap-4 sm:gap-6 mb-10 sm:mb-16">
            <div className="bg-white rounded-2xl p-5 sm:p-8 shadow-lg border-2 border-[#C5A880]/30 hover:border-[#C5A880] transition-all duration-300">
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-5">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#1A2B4C] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-line text-lg sm:text-xl text-[#C5A880]"></i>
                </div>
                <h2 className="text-xl sm:text-2xl font-bold text-[#1A2B4C] font-['Playfair_Display']">Клиент</h2>
              </div>
              <div className="mb-4 sm:mb-5">
                <img
                  src="https://convertmonster.ru/wp-content/themes/convertmonster/img/cm-2023/cases/case_dunaev_logo.png"
                  alt="Логотип Дунаев"
                  className="h-12 sm:h-16 w-auto object-contain mb-3 sm:mb-4"
                />
              </div>
              <p className="text-gray-700 text-sm leading-relaxed mb-3 font-['Montserrat'] text-justify">
                «Дунаев» — оптовый поставщик рыболовной прикормки. Целью нашего клиента являются оптовые продажи в Москве и Московской области, так как он является официальным дистрибьютором марки в этом регионе.
              </p>
              <div className="grid grid-cols-2 gap-2 sm:gap-3 mt-3 sm:mt-4">
                <div className="bg-[#F8F9FA] border border-[#C5A880]/30 rounded-xl p-2 sm:p-3 text-center">
                  <div className="text-sm font-bold text-[#1A2B4C] font-['Montserrat']">B2B</div>
                  <div className="text-xs text-gray-500 mt-0.5 font-['Montserrat']">Направление</div>
                </div>
                <div className="bg-[#F8F9FA] border border-[#C5A880]/30 rounded-xl p-2 sm:p-3 text-center">
                  <div className="text-xs sm:text-sm font-bold text-[#1A2B4C] font-['Montserrat']">Москва + МО</div>
                  <div className="text-xs text-gray-500 mt-0.5 font-['Montserrat']">Регион</div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-5 sm:p-8 shadow-lg border-2 border-[#C5A880]/30 hover:border-[#C5A880] transition-all duration-300">
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-5">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#1A2B4C] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-flag-line text-lg sm:text-xl text-[#C5A880]"></i>
                </div>
                <h2 className="text-xl sm:text-2xl font-bold text-[#1A2B4C] font-['Playfair_Display']">Задача</h2>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed mb-4 sm:mb-5 font-['Montserrat'] text-justify">
                Разработать продающий лендинг и рекламные кампании в Яндекс и Google.
              </p>
              <div className="space-y-2 sm:space-y-3">
                {[
                  { icon: 'ri-layout-line', text: 'Создание продающего Landing Page под оптовые продажи' },
                  { icon: 'ri-search-eye-line', text: 'Запуск контекстной рекламы в Яндекс Директ и Google Ads' },
                  { icon: 'ri-team-line', text: 'Генерация B2B лидов — оптовых покупателей' },
                  { icon: 'ri-map-pin-line', text: 'Фокус на Москве и Московской области' },
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-2 sm:gap-3">
                    <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center bg-[#C5A880]/10 rounded-lg flex-shrink-0">
                      <i className={`${item.icon} text-sm sm:text-base text-[#C5A880]`}></i>
                    </div>
                    <p className="text-sm text-gray-700 leading-relaxed font-['Montserrat'] text-justify">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Section: Stages of work */}
          <div className="mb-10 sm:mb-16">
            <div className="text-center mb-8 sm:mb-12">
              <div className="inline-flex items-center gap-2 bg-[#1A2B4C]/10 text-[#1A2B4C] px-4 sm:px-5 py-2 rounded-full text-xs sm:text-sm font-semibold mb-3 sm:mb-4 font-['Montserrat']">
                <i className="ri-tools-line"></i>
                Этапы работ
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold text-[#1A2B4C] mb-2 sm:mb-3 font-['Playfair_Display']">
                Структура продающего лендинга
              </h2>
              <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto font-['Montserrat']">
                Каждый экран лендинга спроектирован с учётом задач B2B воронки — от первого касания до оставления заявки
              </p>
            </div>

            <div className="space-y-8 sm:space-y-10">
              {stagesWork.map((stage, idx) => (
                <div
                  key={idx}
                  className={`flex flex-col ${idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} gap-5 sm:gap-8 items-center`}
                >
                  {/* Image */}
                  <div className="w-full md:w-3/5 flex-shrink-0">
                    <div className="rounded-2xl overflow-hidden border-2 border-[#C5A880]/30 shadow-lg w-full">
                      <img
                        src={stage.img}
                        alt={stage.label}
                        className="w-full h-auto object-top"
                      />
                    </div>
                  </div>
                  {/* Text */}
                  <div className="w-full md:w-2/5">
                    <div className="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-3">
                      <div className="w-8 h-8 sm:w-9 sm:h-9 bg-[#1A2B4C] rounded-full flex items-center justify-center flex-shrink-0">
                        <span className="text-[#C5A880] text-xs sm:text-sm font-bold font-['Montserrat']">
                          {String(idx + 1).padStart(2, '0')}
                        </span>
                      </div>
                      <span className="text-xs font-bold text-[#C5A880] uppercase tracking-wider font-['Montserrat']">
                        {stage.label}
                      </span>
                    </div>
                    <p className="text-gray-700 leading-relaxed text-sm font-['Montserrat'] text-justify">
                      {stage.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Context Advertising Section */}
          <div className="bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] rounded-2xl p-5 sm:p-8 md:p-12 text-white mb-10 sm:mb-16 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 border-2 border-[#C5A880]/10 rounded-full -mr-32 -mt-32 hidden sm:block"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 border-2 border-[#C5A880]/10 rounded-full -ml-24 -mb-24 hidden sm:block"></div>

            <div className="relative z-10">
              <div className="text-center mb-7 sm:mb-10">
                <div className="inline-flex items-center gap-2 bg-white/10 text-[#C5A880] px-4 sm:px-5 py-2 rounded-full text-xs sm:text-sm font-semibold mb-3 sm:mb-4 font-['Montserrat']">
                  <i className="ri-advertisement-line"></i>
                  Контекстная реклама
                </div>
                <h2 className="text-2xl sm:text-3xl font-bold font-['Playfair_Display']">
                  Параллельный запуск рекламных кампаний
                </h2>
                <p className="text-[#C5A880]/80 text-base sm:text-lg mt-2 sm:mt-3 max-w-2xl mx-auto font-['Montserrat']">
                  Параллельно с разработкой сайта шли работы по рекламным кампаниям в Яндекс и Google
                </p>
              </div>

              <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5 mb-7 sm:mb-10 items-stretch">
                {[
                  {
                    icon: 'ri-search-line',
                    title: 'Семантическое ядро',
                    text: 'Совместно с заказчиком было собрано семантическое ядро с запросами об оптовой продаже рыболовных товаров.',
                  },
                  {
                    icon: 'ri-file-text-line',
                    title: 'B2B объявления',
                    text: 'В заголовках объявлений дополнительно подчеркнули B2B направление — акцент на оптовых условиях.',
                  },
                  {
                    icon: 'ri-image-line',
                    title: 'Баннер на поиске',
                    text: 'Дополнительно, по просьбе клиента, запустили баннер на поиске Яндекс для охвата целевой аудитории.',
                  },
                  {
                    icon: 'ri-google-line',
                    title: 'Показ рекламы в поиске Google',
                    text: 'Запустили поисковые объявления в Google Ads — клиент попал в ТОП рекламной выдачи по ключевым запросам об оптовой прикормке.',
                  },
                ].map((item, i) => (
                  <div key={i} className="flex flex-col bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-5 border border-[#C5A880]/30 hover:bg-white/15 transition-all duration-300 h-full">
                    <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-[#C5A880]/20 rounded-lg mb-2 sm:mb-3 flex-shrink-0">
                      <i className={`${item.icon} text-lg sm:text-xl text-[#C5A880]`}></i>
                    </div>
                    <h4 className="text-sm sm:text-base font-bold mb-1 sm:mb-2 font-['Playfair_Display']">{item.title}</h4>
                    <p className="text-xs sm:text-sm text-white/80 leading-relaxed font-['Montserrat'] flex-1 text-justify">{item.text}</p>
                  </div>
                ))}
              </div>

              {/* Google Search Screenshot */}
              <div className="rounded-2xl overflow-hidden border-2 border-[#C5A880]/30 shadow-xl w-full mb-5 sm:mb-8">
                <img
                  src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/0ee6c7faf3f5d5ee92d995acb2e57906.jpeg"
                  alt="Показ рекламы в поиске Google — прикормка Дунаев"
                  className="w-full h-auto object-top"
                />
              </div>

              {/* Context ads screenshot */}
              <div className="rounded-2xl overflow-hidden border-2 border-[#C5A880]/30 shadow-xl w-full">
                <img
                  src="https://convertmonster.ru/wp-content/themes/convertmonster/img/cm-2023/cases/default_img_dunaev_opt_big_14.jpg"
                  alt="Контекстная реклама Дунаев — скриншот кампании"
                  className="w-full h-auto object-top"
                />
              </div>
            </div>
          </div>

          {/* Creatives for РСЯ and КМС */}
          <div className="mb-10 sm:mb-16">
            <div className="text-center mb-7 sm:mb-10">
              <div className="inline-flex items-center gap-2 bg-[#1A2B4C]/10 text-[#1A2B4C] px-4 sm:px-5 py-2 rounded-full text-xs sm:text-sm font-semibold mb-3 sm:mb-4 font-['Montserrat']">
                <i className="ri-image-2-line"></i>
                Креативы для РСЯ и КМС
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold text-[#1A2B4C] mb-2 sm:mb-3 font-['Playfair_Display']">
                Для кампаний РСЯ и КМС подготовили 2 вида креативов
              </h2>
              <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto font-['Montserrat']">
                Баннеры разработаны под разные форматы рекламных сетей — с акцентом на оффер и визуальное узнавание бренда Dunaev
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-5 sm:gap-8 items-start">
              <div className="rounded-2xl overflow-hidden border-2 border-[#C5A880]/30 hover:border-[#C5A880] transition-all duration-300 flex justify-center bg-[#F8F9FA]">
                <img
                  src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/0de125d0cbfc7b0f53c29287d7f87b5e.jpeg"
                  alt="Креатив 1 для РСЯ и КМС — прикормка Dunaev вертикальный баннер"
                  className="max-w-full h-auto object-top block"
                />
              </div>

              <div className="rounded-2xl overflow-hidden border-2 border-[#C5A880]/30 hover:border-[#C5A880] transition-all duration-300 flex justify-center bg-[#F8F9FA]">
                <img
                  src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/d7355bb290743657b7ed6bf53cb8b65d.jpeg"
                  alt="Креатив 2 для РСЯ и КМС — прикормка Dunaev горизонтальный баннер"
                  className="max-w-full h-auto object-top block"
                />
              </div>
            </div>
          </div>

          {/* Results */}
          <div className="mb-10 sm:mb-16">
            <div className="text-center mb-8 sm:mb-12">
              <div className="inline-flex items-center gap-2 bg-[#1A2B4C]/10 text-[#1A2B4C] px-4 sm:px-5 py-2 rounded-full text-xs sm:text-sm font-semibold mb-3 sm:mb-4 font-['Montserrat']">
                <i className="ri-bar-chart-2-line"></i>
                Результаты
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold text-[#1A2B4C] mb-2 sm:mb-3 font-['Playfair_Display']">
                Итоги двух месяцев работы
              </h2>
              <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto font-['Montserrat'] text-center">
                За два месяца работы рекламных кампаний мы получили 132 конверсии со средней стоимостью 584 руб.
              </p>
              <p className="text-gray-500 text-xs sm:text-sm mt-2 font-['Montserrat']">
                Статистика из Яндекс.Директ, период 1.03.2021 – 1.05.2021
              </p>
            </div>

            {/* Result metrics */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-5 mb-7 sm:mb-10 items-stretch">
              {[
                { icon: 'ri-money-dollar-circle-line', label: 'Рекламный бюджет', value: '77 119 ₽', sub: 'за 2 месяца' },
                { icon: 'ri-cursor-line', label: 'Цена клика', value: '19,18 ₽', sub: 'средняя' },
                { icon: 'ri-checkbox-circle-line', label: 'Кол-во конверсий', value: '132', sub: 'целевых действий', highlight: true },
                { icon: 'ri-price-tag-3-line', label: 'Цена конверсии', value: '584 ₽', sub: 'стоимость лида' },
              ].map((stat, i) => (
                <div
                  key={i}
                  className={`flex flex-col rounded-2xl p-4 sm:p-6 text-center border-2 transition-all duration-300 h-full ${
                    stat.highlight
                      ? 'bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] border-[#C5A880] shadow-xl'
                      : 'bg-white border-[#C5A880]/30 shadow-lg hover:border-[#C5A880]'
                  }`}
                >
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mx-auto mb-2 sm:mb-3 bg-[#C5A880]/10 rounded-full flex-shrink-0">
                    <i className={`${stat.icon} text-xl sm:text-2xl text-[#C5A880]`}></i>
                  </div>
                  <div className={`text-xl sm:text-3xl font-bold font-['Playfair_Display'] ${stat.highlight ? 'text-[#C5A880]' : 'text-[#1A2B4C]'}`}>
                    {stat.value}
                  </div>
                  <div className={`text-xs sm:text-sm font-semibold mt-1 font-['Montserrat'] ${stat.highlight ? 'text-white' : 'text-[#1A2B4C]'}`}>
                    {stat.label}
                  </div>
                  <div className={`text-xs mt-0.5 font-['Montserrat'] ${stat.highlight ? 'text-[#C5A880]/80' : 'text-gray-500'}`}>
                    {stat.sub}
                  </div>
                </div>
              ))}
            </div>

            {/* Results screenshot */}
            <div className="rounded-2xl overflow-hidden border-2 border-[#C5A880]/30 shadow-xl w-full mb-7 sm:mb-10">
              <img
                src="https://convertmonster.ru/wp-content/themes/convertmonster/img/cm-2023/cases/default_img_dunaev_opt_big_16.jpg"
                alt="Результаты рекламных кампаний Дунаев — статистика Яндекс Директ"
                className="w-full h-auto object-top"
              />
            </div>

            {/* Key achievement */}
            <div className="bg-[#F8F9FA] border-2 border-[#C5A880]/30 rounded-2xl p-5 sm:p-8">
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#1A2B4C] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-trophy-line text-xl sm:text-2xl text-[#C5A880]"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A2B4C] mb-2 sm:mb-3 text-lg sm:text-xl font-['Playfair_Display']">Главный итог</h3>
                  <div className="space-y-2 text-sm text-gray-700 font-['Montserrat']">
                    <p>
                      <strong>132 заявки за 2 месяца</strong> на рыболовную прикормку по оптовым условиям — результат системной работы над лендингом и рекламными кампаниями.
                    </p>
                    <p className="text-justify">
                      Продающий лендинг с правильной структурой и выгодным оффером («зарабатывай от 300 000 ₽ за сезон») в связке с контекстной рекламой обеспечил стабильный поток B2B лидов.
                    </p>
                    <p className="text-[#C5A880] font-semibold">
                      Бюджет 77 119 ₽ → 132 конверсии → цена конверсии всего 584 ₽.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Footnote */}
            <p className="text-gray-400 text-xs mt-4 font-['Montserrat'] text-right">
              Работа проводилась совместно с Агентством Интернет-Маркетинга ConvertMonster
            </p>

          </div>

          {/* CTA */}
          <div className="text-center py-10 sm:py-14 px-4 sm:px-8 bg-gradient-to-br from-[#1A2B4C] to-[#0F1A2E] rounded-3xl border-2 border-[#C5A880]/30 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-48 h-48 border-2 border-[#C5A880]/10 rounded-full -mr-24 -mt-24 hidden sm:block"></div>
            <div className="absolute bottom-0 left-0 w-40 h-40 border-2 border-[#C5A880]/10 rounded-full -ml-20 -mb-20 hidden sm:block"></div>

            <div className="relative z-10">
              <h2 className="text-xl sm:text-3xl font-bold text-white mb-3 sm:mb-4 font-['Playfair_Display']">
                Хотите такой же результат для вашего бизнеса?
              </h2>
              <p className="text-white/80 text-sm sm:text-lg mb-6 sm:mb-8 max-w-2xl mx-auto font-['Montserrat']">
                Разработаем продающий лендинг и запустим контекстную рекламу, которая приносит реальные B2B заявки по приемлемой цене.
              </p>
              <Link
                to="/#lead-form"
                className="inline-block bg-[#C5A880] text-[#1A2B4C] px-6 sm:px-10 py-3 sm:py-5 rounded-full text-base sm:text-xl font-bold hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer font-['Montserrat']"
              >
                Обсудить мой проект
              </Link>
            </div>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}
